import { actionGenerator } from "utils";
import {
  REQUEST_SMS_OTP,
  VERIFY_OTP,
  OTP_LOG,
  REQUEST_LOGIN,
  UPDATE_USER_INFO,
  REQUEST_GIGYA,
  EXCHANGE_CODE,
  TOPUP_MOBILE,
  GET_DISTRICTS,
  GET_MARTS,
  UPDATE_DELIVERY,
  GET_PROVINCES,
  CHECK_PHONE,
  REQUEST_EMAIL_OTP,
  RESET_PASSWORD,
  GET_NEWS,
  GET_POINTS,
  GET_GIFT_LIST,
  GET_GIFT_DETAIL,
  GET_MY_GIFTS,
  GET_MY_GIFT_DETAIL,
  REDEEM_GIFT,
  USE_GIFT,
  GET_SLOTS,
  BOOK_TICKET,
  GET_CAMPAIGN_INFO,
  GET_CARDS,
  COUNT_CARDS,
  DETECT_IMAGE,
  DETECT_TEXT,
  CREATE_CARD,
} from "./constants";

const actions = {
  REQUEST_SMS_OTP: actionGenerator.genActions(REQUEST_SMS_OTP),
  REQUEST_EMAIL_OTP: actionGenerator.genActions(REQUEST_EMAIL_OTP),
  OTP_LOG: actionGenerator.genActions(OTP_LOG),
  VERIFY_OTP: actionGenerator.genActions(VERIFY_OTP),
  REQUEST_LOGIN: actionGenerator.genActions(REQUEST_LOGIN),
  UPDATE_USER_INFO: actionGenerator.genActions(UPDATE_USER_INFO),
  REQUEST_GIGYA: actionGenerator.genActions(REQUEST_GIGYA),
  EXCHANGE_CODE: actionGenerator.genActions(EXCHANGE_CODE),
  TOPUP_MOBILE: actionGenerator.genActions(TOPUP_MOBILE),
  GET_DISTRICTS: actionGenerator.genActions(GET_DISTRICTS),
  GET_MARTS: actionGenerator.genActions(GET_MARTS),
  UPDATE_DELIVERY: actionGenerator.genActions(UPDATE_DELIVERY),
  GET_PROVINCES: actionGenerator.genActions(GET_PROVINCES),
  CHECK_PHONE: actionGenerator.genActions(CHECK_PHONE),
  RESET_PASSWORD: actionGenerator.genActions(RESET_PASSWORD),
  GET_NEWS: actionGenerator.genActions(GET_NEWS),
  GET_POINTS: actionGenerator.genActions(GET_POINTS),
  GET_GIFT_LIST: actionGenerator.genActions(GET_GIFT_LIST),
  GET_GIFT_DETAIL: actionGenerator.genActions(GET_GIFT_DETAIL),
  GET_MY_GIFTS: actionGenerator.genActions(GET_MY_GIFTS),
  GET_MY_GIFT_DETAIL: actionGenerator.genActions(GET_MY_GIFT_DETAIL),
  REDEEM_GIFT: actionGenerator.genActions(REDEEM_GIFT),
  USE_GIFT: actionGenerator.genActions(USE_GIFT),
  GET_SLOTS: actionGenerator.genActions(GET_SLOTS),
  BOOK_TICKET: actionGenerator.genActions(BOOK_TICKET),
  //PS 8/3
  GET_CAMPAIGN_INFO: actionGenerator.genActions(GET_CAMPAIGN_INFO),
  GET_CARDS: actionGenerator.genActions(GET_CARDS),
  COUNT_CARDS: actionGenerator.genActions(COUNT_CARDS),
  DETECT_IMAGE: actionGenerator.genActions(DETECT_IMAGE),
  DETECT_TEXT: actionGenerator.genActions(DETECT_TEXT),
  CREATE_CARD: actionGenerator.genActions(CREATE_CARD),
};

export default actions;
